import { MenuOutlined } from '@ant-design/icons'
import { Button, Drawer, Image } from 'antd'
import { Fragment, useState } from 'react'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useTranslation } from 'translations'
import { MENU_CONFIGS } from './config'
import { AppDownload } from 'pages/Home/components/Banner'
import { DropDownLanguage } from 'components/Footer'
import RouteList from 'pages/Routes'
import { twMerge } from 'tailwind-merge'
import { isLogin } from 'pages/App'

function Header() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false)

  const toggleMobileMenu = () => setIsOpenMobileMenu((prev) => !prev)
  const handleNavigate = (url: string) => {
    toggleMobileMenu()
    navigate(url)
  }

  return (
    <>
      <WrapperHeader>
        <div className='container body !px-0'>
          <div className='menu'>
            <MenuLeft className='cursor-pointer'>
              <NavLink to="/">
                <Image preview={false} src='/images/logo/main-logo.svg?v=1.4' className='!w-12' />
              </NavLink>

              <ul className='content-list' onClick={() => navigate(RouteList.home)}>
                <li className='text-lg font-bold leading-[1]'>Alo</li>
                <li className='text-lg font-bold leading-[1]'>Wallet</li>
              </ul>
            </MenuLeft>

            <div className="flex items-center gap-3">
              <MenuOutlined className='mobile-menu' onClick={toggleMobileMenu} />
            </div>
          </div>
        </div>
      </WrapperHeader>

      <Drawer
        title={<Image preview={false} src='/images/logo/main-logo.svg?v=1.4' className='!w-12' onClick={() => handleNavigate(RouteList.home)} />}
        onClose={toggleMobileMenu}
        open={isOpenMobileMenu}
        width="100%"
        placement='top'
        height="100%"
      >
        <div className="flex flex-col gap-4">
          {
            !isLogin() && (
              <Fragment>
                <div className="flex items-center gap-2">
                  <Button type="primary" className='min-h-[42px] flex-1' onClick={() => handleNavigate(RouteList.signIn)}>
                    {t("Login")}
                  </Button>
                  <Button color="primary" variant="outlined" className='min-h-[42px] flex-1' onClick={() => handleNavigate(RouteList.signUp)}>
                    {t("Register")}
                  </Button>
                </div>
                <Line />
              </Fragment>
            )
          }

          {MenuRight(location.pathname)}
          <Line />

          <DropDownLanguage />
          <Line />

          <div className="flex flex-col gap-2">
            <p className="text-base text-[#858792]">{t("Download")}</p>
            <AppDownload />
          </div>
        </div>
      </Drawer>
    </>
  )
}
export default Header


export const Line = ({ className = '' }) => <div className={twMerge('w-full h-[1px] bg-[#e2e3e5] my-2', className)} />

const MenuRight = (currentPath, isPC = false) => {
  const { t } = useTranslation()

  return (
    <MenuRightWrapper className={isPC ? 'pc' : ''}>
      {MENU_CONFIGS?.map((menu) => {
        const active = menu?.actives?.includes(currentPath)

        return (
          <li key={menu?.label} className={active ? 'menu-item active' : 'menu-item'}>
            {menu?.external ? (
              <a href={menu?.href} target='_blank' rel='noreferrer'>
                {t(menu?.label)}
              </a>
            ) : (
              <Link to={menu?.href as string}>
                {t(menu?.label)}
              </Link>
            )}
          </li>
        )
      })}
    </MenuRightWrapper>
  )
}

const WrapperHeader = styled.header`
  width: 100%;
  background: #fff;

  .body {
    padding: 15px;

    .menu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;

      .mobile-menu {
        display: block;

        svg {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
`

const MenuRightWrapper = styled.ul`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  flex-wrap: wrap;

  width: 100%;
  list-style: none;
  flex: 1;

  /* ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
    align-items: center;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    gap: 24px;
  } */

  &.pc {
    display: none;

    ${({ theme }) => theme.mediaQueries.md} {
      display: flex;
    }
  }

  .menu-item {
    font-weight: 600;

    a {
      text-transform: uppercase;
      transition: all 0.2s ease-in;
    }

    &:hover a {
      color: var(--primary-color);
    }

    &.active {
      color: var(--primary-color);
    }
  }
`

const MenuLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  > a {
    flex-shrink: 0;
  }

  .menu-logo {
    width: 100%;
    max-width: 70px;
  }

  .content-list {
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

